import { useState } from 'react';
import { sessionAPI } from '../services/api';
import './JoinGameModal.css';

export default function JoinGameModal({ character, onJoin, onCancel }) {
  const [inviteCode, setInviteCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCodeChange = (e) => {
    // Only allow alphanumeric characters, max 8
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
    setInviteCode(value);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (inviteCode.length !== 8) {
      setError('Please enter a valid 8-character invite code');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await sessionAPI.joinSession(inviteCode, character._id);
      onJoin(response.data.game);
    } catch (err) {
      console.error('Join game error:', err);
      setError(err.response?.data?.error || 'Failed to join game. Check the invite code and try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="join-game-modal">
        <div className="modal-header">
          <h2>Join Multiplayer Game</h2>
          <button className="close-btn" onClick={onCancel}>&times;</button>
        </div>

        <div className="modal-body">
          <div className="character-preview">
            <p>Joining as:</p>
            <div className="character-badge">
              <span className="character-name">{character.name}</span>
              <span className="character-class">
                Level {character.level} {character.class}
              </span>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="inviteCode">Enter Invite Code</label>
              <input
                type="text"
                id="inviteCode"
                value={inviteCode}
                onChange={handleCodeChange}
                placeholder="XXXXXXXX"
                className="invite-code-input"
                autoFocus
                autoComplete="off"
                disabled={loading}
              />
              <p className="input-hint">
                Ask the host for their 8-character invite code
              </p>
            </div>

            {error && <div className="error-message">{error}</div>}

            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading || inviteCode.length !== 8}
              >
                {loading ? 'Joining...' : 'Join Game'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
